import { render, staticRenderFns } from "./TheThgAdminList.vue?vue&type=template&id=e74ec52e&scoped=true"
import script from "./TheThgAdminList.vue?vue&type=script&lang=ts"
export * from "./TheThgAdminList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74ec52e",
  null
  
)

export default component.exports